<template>
	<div class="b-fieldBlock">
		<div v-if="hasLabel" class="b-fieldBlock__label">
			<slot name="label">
				{{ label }}
			</slot>

			<!-- <BIcon
				class="b-fieldBlock__labelIcon b-fieldBlock__labelIcon--default"
				name="Placeholder"
			/> -->
			<BIcon
				class="b-fieldBlock__labelIcon b-fieldBlock__labelIcon--warning"
				name="Warning"
			/>
			<BIcon
				class="b-fieldBlock__labelIcon b-fieldBlock__labelIcon--error"
				name="Error"
			/>
		</div>

		<div class="b-fieldBlock__body">
			<slot name="default" />
		</div>
	</div>
</template>

<script>
import BIcon from "@/components/base/BIcon";

export default {
	components: {
		BIcon,
	},
	props: {
		label: {
			type: String,
			default: "",
		},
	},
	data() {
		return {};
	},
	computed: {
		allSlots() {
			return {
				...this.$slots,
				...this.$scopedSlots,
			};
		},
		classes() {
			return [];
		},
		hasLabel() {
			return (
				this.allSlots.label ||
				(typeof this.label === "string" && this.label.length > 0)
			);
		},
		listeners() {
			return {
				...this.$listeners,
				input: (event) => {
					this.$emit("input", event.target.value);
				},
			};
		},
	},
};
</script>

<style lang="scss">
.b-fieldBlock__label {
	color: var(--color-neutral-500);
	font-size: var(--font-size-s);
	margin-bottom: 8px;
	padding-left: 16px;
	display: flex;
	align-items: center;
	gap: 4px;
	word-break: break-word;
}

.b-fieldBlock__labelIcon {
	display: none;
}

.b-fieldBlock__labelIcon--warning {
	color: var(--color-warning-300);
}

.b-fieldBlock__labelIcon--error {
	color: var(--color-error-300);
}

.b-fieldBlock:not(:has(.is-warning, .is-error)) {
	.b-fieldBlock__labelIcon--default {
		display: block;
	}
}

.b-fieldBlock:has(.is-warning) {
	.b-fieldBlock__labelIcon--warning {
		display: block;
	}
}

.b-fieldBlock:has(.is-error) {
	.b-fieldBlock__labelIcon--error {
		display: block;
	}
}

.colorCtx-dark {
	.b-fieldBlock__label {
		color: var(--color-netural-0);
	}
}
</style>
